import { useCallback, useEffect } from 'react';

import { useAppSelector } from 'src/store/reducers';

export const useHandleDocumentTitle = (microwebOrStep: boolean | undefined): void => {
  const formTitle = useAppSelector(state => state.refero.form?.FormDefinition?.Content?.title);
  const updateDocumentTitle = useCallback((): void => {
    if (!microwebOrStep) {
      if (formTitle) {
        document.title = `${formTitle} - Helsenorge`;
      } else {
        document.title = 'Skjemautfyller - Helsenorge';
      }
    }
  }, [formTitle, microwebOrStep]);
  useEffect(() => {
    updateDocumentTitle();
  }, [formTitle, microwebOrStep, updateDocumentTitle]);
};
